/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber11Small = createReactComponent("number-11-small", "IconNumber11Small", [
  ["path", { d: "M8 10l2 -2v8", key: "svg-0" }],
  ["path", { d: "M14 10l2 -2v8", key: "svg-1" }]
]);

export { IconNumber11Small as default };
//# sourceMappingURL=IconNumber11Small.js.map
